<template>
  <!-- 司机管理 -->
   <div  class="treeBigBox app-container">
     <!--树形结构-->
    <div class="boxLeft">
      <div class="title">
        <div class="xian"></div>
        <div> 司机管理</div>
      </div>
      <div class="treeBox">
        <el-tree :data="orgTreeData"
          node-key="id"
          ref="orgTree"
          :props="defaultProps"
          :default-expand-all="true"
          :expand-on-click-node="false"
          :current-node-key="currentData.orgId"
          :highlight-current="true"
           :render-content="renderContent"
          @node-click="handleNodeClick">
        </el-tree>
      </div>
    </div>

  <div class="right">
    <SearchCollapse @update-height="getHeight" :formItemsLength="8" :desktopCount="8" :mobileCount="6">
      <div class="formBox" ref="searchBox">
          <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
            <div class="formItemBox formItemWid">
              <el-form-item label="司机姓名:">
                <el-input placeholder="" v-model="searchFrom.nameLike"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input placeholder="" v-model="searchFrom.mobile"></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="identityNo">
                <el-input placeholder="" v-model="searchFrom.identityNo"></el-input>
              </el-form-item>
              <el-form-item label="创建时间:" prop="createTimes">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <br>
              <el-form-item label="驾驶证号:" prop="certificateNum">
                <el-input placeholder="" v-model="searchFrom.certificateNum"></el-input>
              </el-form-item>
              <el-form-item label="身份地址:" prop="address">
                <el-input placeholder="" v-model="searchFrom.address" ></el-input>
              </el-form-item>
              <el-form-item label="作业状态:">
                <el-select v-model="searchFrom.jobStatus" filterable placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="待作业" value="20" ></el-option>
                  <el-option label="作业中" value="30" ></el-option>
                  <el-option label="已下线" value="10" ></el-option>
                  <el-option label="休假中" value="40" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="人事状态:">
                <el-select v-model="searchFrom.employmentStatus" filterable placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="在职" value="1" ></el-option>
                  <el-option label="离职" value="2" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入职时间:" prop="joinedDates">
                <el-date-picker
                  v-model="searchFrom.joinedDates"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="是否五险:">
                <el-select v-model="searchFrom.fiveInsurances" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                    <el-option label="是" value="1" ></el-option>
                    <el-option label="否" value="0" ></el-option>
                  </el-select>
              </el-form-item>
          </div>
          <div class="searchBtnBox">
              <el-button type="primary" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
              <el-button type="primary" @click="resetForm('searchFrom')"  v-if="btnFlg[1]">重置</el-button>
              <el-button type="primary"  @click="addDeiver" v-if="btnFlg[2]&&zhuhuCode==currentData.tenantCode">新增</el-button>
              <el-button type="primary" @click="delDeiver"  v-if="btnFlg[3]&&zhuhuCode==currentData.tenantCode">删除</el-button>
              <el-button type="primary" size="mini" @click="exportFn" v-if="btnFlg[11]" :disabled="isDisable">导出</el-button>
              <el-button type="primary"  v-if="btnFlg[12]" @click="bdcysFN">绑定承运商</el-button>
          </div>
          </el-form>
        </div>
    </SearchCollapse>
        <!--  表格 -->
        <div class="table" :style="{height:h}">
          <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' class="tableComent"
          @row-click="handleRowClick" height="100%"   style="width: 100%" center border :cell-style="getCellStyle">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
            <el-table-column label="操作" width="190">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" size="mini"  v-if="btnFlg[4]&&zhuhuCode==currentData.tenantCode" @click="modifyDeiver(scope.row)">修改</el-button>
                  <!-- <el-button type="text" size="mini"   v-if="btnFlg[7]&&scope.row.blacklistStatus== '0'&&zhuhuCode==currentData.tenantCode" @click="laheiFn(scope.row)">拉黑</el-button>
                    <el-button type="text" size="mini"   v-if="btnFlg[8]&& scope.row.blacklistStatus== '1'&&zhuhuCode==currentData.tenantCode" @click="jiesuoFn(scope.row)">解锁</el-button> -->
                  <el-button type="text" size="mini"   v-if="btnFlg[5]" v-show="scope.row.accountStatus==1&&zhuhuCode==currentData.tenantCode" @click="ktzhFn(scope.row)">开通账号</el-button>
                  <el-button type="text" size="mini" @click="bgzhFn(scope.row)" v-show="btnFlg[9]&scope.row.accountStatus==2&&zhuhuCode==currentData.tenantCode">变更账号</el-button>
                  <el-button type="text" size="mini" @click="diaoboFn(scope.row)" v-if="btnFlg[10]&&zhuhuCode==currentData.tenantCode">调拨</el-button>
                  <el-button type="text" size="mini" @click="liZhiFn(scope.row)" v-if="btnFlg[13]&&zhuhuCode==currentData.tenantCode && scope.row.employmentStatus == '1'">离职</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" width="80" :formatter="emptyFn" :show-overflow-tooltip="true"  label="司机姓名">
              <template slot-scope="scope">
                  <div>
                    <el-button type="text" size="mini"  @click="lookFn(scope.row)">{{scope.row.name}}</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" width="120" :formatter="emptyFn" label="联系电话" show-overflow-tooltip></el-table-column>
            <el-table-column prop="temporaryFlg" width="80" :show-overflow-tooltip="true" :formatter="emptyFn" label="作业状态">
              <template slot-scope="scope">
                <div>
                  <div v-if="scope.row.jobStatus == '10'" >已下线</div>
                  <div  v-if="scope.row.jobStatus == '20'" style="color:#F73004">待作业</div>
                  <div  v-if="scope.row.jobStatus == '30'" style="color:#F3BF1C">作业中</div>
                  <div  v-if="scope.row.jobStatus == '40'" style="color:#8E8E8E">休假中</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="employmentStatus" width="80" :show-overflow-tooltip="true" :formatter="emptyFn" label="人事状态">
              <template slot-scope="scope">
                <div>
                  <div v-if="scope.row.employmentStatus == '1'">在职</div>
                  <div v-if="scope.row.employmentStatus == '2'">离职</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="identityNo" width="180" :formatter="emptyFn"  label="身份证号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="identityExpiringDate" width="120" :formatter="emptyFn"  label="身份证到期日" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="address" width="150" :formatter="emptyFn"  label="身份证地址" show-overflow-tooltip></el-table-column> -->
            <!-- <el-table-column prop="qualificationOverdue" width="80" :show-overflow-tooltip="true" :formatter="emptyFn" label="状态">
              <template slot-scope="scope">
                <div>
                  <div v-if="scope.row.blacklistStatus == '0'">正常</div>
                  <div  v-if="scope.row.blacklistStatus == '1'">已拉黑</div>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column prop="teamOrgName" width="120" :show-overflow-tooltip="true" :formatter="emptyFn" label="所属队"></el-table-column>
            <!-- <el-table-column prop="operationOrgName" width="120" :show-overflow-tooltip="true" :formatter="emptyFn" label="所属组"></el-table-column> -->
            <el-table-column prop="joinedDate" min-width="120" :formatter="dateFormat"  label="入职日期"></el-table-column>
            <el-table-column prop="licenseNum" min-width="170" :show-overflow-tooltip="true" :formatter="emptyFn" label="驾驶证号"></el-table-column>
            <el-table-column prop="validPeriodTo" min-width="120" :show-overflow-tooltip="true" :formatter="emptyFn" label="驾驶证到期日"></el-table-column>
            <el-table-column prop="qualificationNum" min-width="170" :show-overflow-tooltip="true" :formatter="emptyFn" label="从业资格证号"></el-table-column>
            <el-table-column prop="qualificationTo" min-width="120" :show-overflow-tooltip="true" :formatter="emptyFn" label="从业资格到期日"></el-table-column>
            <el-table-column prop="ext1" width="160"   :show-overflow-tooltip="true"  label="挂靠承运商"></el-table-column>
            <el-table-column property="fiveInsurances" label="五险" >
              <template scope="scope">
                {{[ "否", "是" ][scope.row.fiveInsurances]}}
              </template>
            </el-table-column>
            <el-table-column prop="createUserName" min-width="100" :show-overflow-tooltip="true" :formatter="emptyFn" label="创建人"></el-table-column>
            <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div>
          <el-pagination background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchFrom.pageNo"
            :page-sizes="[25,50,100]"
            :page-size="searchFrom.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
        <!-- 司机的新增修改 -->
        <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialogB('addFrom')" width="1240px" center>
          <span>
            <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="130px" size="mini" v-if="dialogVisible">
            <!-- <el-form-item label="所属分级：" label-width="100px" >
               <el-cascader v-if="!isAdd" v-model="addFrom.operationOrgId" style="width:400px" ref="zuzhicascader" @change="zuzhiChange" :options="BMlist"  :props="{ expandTrigger:'hover',  label:'name',value:'id',emitPath:false}"  ></el-cascader>
               <span v-else>{{zuzhiquanming}}</span>
            </el-form-item> -->
            <!-- <el-form-item label="绑定车数量限制：" label-width="140px" >
              <el-select v-model="addFrom.bindCarNumber"   placeholder="请选择" >
                  <el-option label="1" value="1" ></el-option>
                  <el-option label="2" value="2" ></el-option>
                  <el-option label="3" value="3" ></el-option>
                  <el-option label="4" value="4" ></el-option>
                  <el-option label="5" value="5" ></el-option>
                </el-select>
            </el-form-item> -->
            <div class="inpBoxA">
                <div class="addressBox">
                  <h4 class="title">
                    <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
                  </h4>
                </div>
                <div style="display: flex;">
                  <div class="box" v-if="newImgFlag">
                    <div class="imgBox">
                        <uploadImg :img='img' key="0" @remove ='handleRemove'  @change ='imgPreview'></uploadImg>
                        <h6 class="is-need">身份证正面</h6>
                    </div>
                    <div class="imgBox" style="margin-bottom:10px">
                      <uploadImg :img='img1' key="1" @remove ='handleRemove1' @change ='imgPreview1'></uploadImg>
                      <h6  class="is-need">身份证背面</h6>
                    </div>
                    <div class="imgBox" >
                        <uploadImg :img='img2' key="2" @remove ='handleRemove2' @change ='imgPreview2'></uploadImg>
                        <h6  class="is-need">驾驶证正面</h6>
                    </div>
                    <div class="imgBox" style="margin-bottom:10px">
                        <uploadImg :img='img3' key="3" @remove ='handleRemove3' @change ='imgPreview3'></uploadImg>
                        <h6  class="is-need">驾驶证背面</h6>
                    </div>
                    <div class="imgBox">
                        <uploadImg :img='img4' key="4" @remove ='handleRemove4' @change ='imgPreview4'></uploadImg>
                        <h6  class="is-need">道路运输从业资格证(支持老版)</h6>
                    </div>
                  </div>
                  <div>
                    <div class="borderBox" style="padding-top:40px;margin-bottom:25px">
                      <el-form-item label="司机姓名:" prop="name">
                        <el-input placeholder="" maxlength="20" v-model.trim="addFrom.name"></el-input>
                      </el-form-item>
                      <el-form-item label="联系电话:" prop="mobile">
                        <el-input placeholder="" maxlength="11" v-number-input.float="0" v-model="addFrom.mobile"></el-input>
                      </el-form-item>
                      <el-form-item label="入职日期:" prop="joinedDate">
                        <el-date-picker
                          v-model="addFrom.joinedDate"
                          format="yyyy-MM-dd"
                          value-format="timestamp"
                          type="date"
                          placeholder="选择日期时间"
                        ></el-date-picker>
                      </el-form-item>
                      <el-form-item label="身份证号:" prop="identityNo">
                        <el-input placeholder=""  maxlength="18" v-model.trim="addFrom.identityNo" style=" width:160px"></el-input>
                      </el-form-item>
                      <!-- <el-form-item label="身份证地址:" prop="address" >
                        <el-input  placeholder=""  maxlength="100" v-model.trim="addFrom.address" style=" width: 440px"></el-input>
                      </el-form-item> -->
                      <el-form-item label="五险:" prop="fiveInsurances">
                        <el-radio-group v-model="addFrom.fiveInsurances">
                          <el-radio label="0">否</el-radio>
                          <el-radio label="1">是</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="身份证开始日期:" prop="identityStratDate">
                        <el-date-picker
                          v-model="addFrom.identityStratDate"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期时间"
                        ></el-date-picker>
                      </el-form-item>
                      <el-form-item label="身份证是否长期:" prop="sfzcq " class="ziti" >
                        <template >
                          <div style="width:150px">
                            <el-radio-group v-model="addFrom.sfzcq">
                              <el-radio :label="1" >是</el-radio>
                              <el-radio :label="2">否</el-radio>
                            </el-radio-group>
                          </div>
                        </template>
                      </el-form-item>
                      <el-form-item label="身份证有效期:" prop="identityExpiringDate" v-if="addFrom.sfzcq==2">
                        <el-date-picker
                          v-model="addFrom.identityExpiringDate"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期时间"
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                    <div class="borderBox" style="padding-top:40px;margin-bottom:25px">
                      <el-form-item label="驾驶证号:" prop="licenseNum">
                        <el-input  placeholder="" maxlength="50" v-model.trim="addFrom.licenseNum" style=" width:450px"></el-input>
                      </el-form-item>
                      <br>
                      <el-form-item label="准驾车型:" filterable prop="quasiDriving" >
                          <el-select placeholder="请选择" multiple v-model="addFrom.quasiDriving">
                            <el-option
                              v-for="(item,index) in zjcx"
                              :key="index"
                              :label="item"
                              :value="item"
                            ></el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item label="驾驶证发证机关:"  prop="issueAuthority" label-width="140px">
                        <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.issueAuthority" style=" width:430px"></el-input>
                      </el-form-item>
                      <br>
                      <el-form-item label="驾照起始日期:" prop="validPeriodFrom">
                        <el-date-picker
                          v-model="addFrom.validPeriodFrom"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期时间"
                        ></el-date-picker>
                      </el-form-item>
                      <el-form-item label="驾照是否长期:" prop="jzcq " class="ziti"  >
                        <template >
                          <div style="width:150px">
                            <el-radio-group v-model="addFrom.jzcq">
                              <el-radio :label=1 >是</el-radio>
                              <el-radio :label=2>否</el-radio>
                            </el-radio-group>
                          </div>
                        </template>
                      </el-form-item>
                      <el-form-item label="驾照结束日期:" prop="validPeriodTo" v-if="addFrom.jzcq==2">
                        <el-date-picker
                          v-model="addFrom.validPeriodTo"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期时间"
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                    <div class="borderBox" style="padding-top:48px;margin-bottom:25px">
                      <el-form-item label="从业资格证号:"  prop="qualificationNum" style=" width:550px">
                        <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.qualificationNum" style=" width:400px"></el-input>
                      </el-form-item>
                      <el-form-item label="从业资格证有效期:" prop="qualificationTo" label-width="140px">
                        <el-date-picker
                          v-model="addFrom.qualificationTo"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期时间"
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <!-- <div class="addressBox">
                  <h4 class="title">
                    <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>保险信息</span>
                  </h4>
                </div> -->
                <div style="padding-bottom:16px"   >
                  <!-- <el-table :data="addFrom.insuranceList" class="bxBox"    bordersize="mini"  style="width: 100%" max-height="500px"  center border v-if="dialogVisible">
                    <el-table-column type="index"  label="序号" width="60"></el-table-column>
                    <el-table-column label="操作"  width="100">
                      <template slot-scope="scope">
                        <div>
                          <el-button type="text" size="mini" @click="addGoodFn(scope.row)">新增</el-button>
                          <el-button type="text" size="mini" @click="delGoodFn(scope.$index)">删除</el-button>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="保险公司" min-width="120">
                      <template slot="header" >
                        <div><span class="red">*</span>保险公司</div>
                      </template>
                      <template slot-scope="scope">
                        <div>
                          <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceCompany'" :key="scope.$index" :rules="rules.insuranceCompany" class="table_error">
                            <el-input placeholder="" maxlength="20"
                              v-model.trim="addFrom.insuranceList[scope.$index].insuranceCompany" ></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="保险项目" min-width="120">
                      <template slot="header" >
                        <div><span class="red">*</span>保险项目</div>
                      </template>
                      <template slot-scope="scope">
                        <div>
                          <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceProject'" :key="scope.$index" :rules="rules.insuranceProject" class="table_error">
                            <el-select  v-model="addFrom.insuranceList[scope.$index].insuranceProject" filterable    >
                              <el-option  label="医疗险" value="医疗险" ></el-option>
                              <el-option  label="重疾险" value="重疾险" ></el-option>
                              <el-option  label="意外险" value="意外险" ></el-option>
                              <el-option  label="车险" value="车险" ></el-option>
                              <el-option  label="工伤保险" value="工伤保险" ></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="最高保险金额" min-width="80">
                      <template slot-scope="scope">
                        <div>
                          <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.maximumAmount'" :key="scope.$index" :rules="rules.maximumAmount" class="table_error">
                            <el-input placeholder="" maxlength="20" v-number-input.float="2"
                              v-model.trim="addFrom.insuranceList[scope.$index].maximumAmount" ></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="保费/年"  min-width="80">
                      <template slot="header" >
                        <div><span class="red">*</span>保费/年</div>
                      </template>
                      <template slot-scope="scope">
                        <div>
                          <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceCosts'" :key="scope.$index" :rules="rules.insuranceCosts"  class="table_error">
                            <el-input placeholder="" maxlength="10" v-number-input.float="2"
                              v-model.trim="addFrom.insuranceList[scope.$index].insuranceCosts" ></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="保单起止日期"  min-width="140">
                      <template slot="header" >
                        <div><span class="red">*</span>保单起止日期</div>
                      </template>
                      <template slot-scope="scope">
                        <div>
                          <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceDate'" :key="scope.$index" :rules="rules.insuranceDate" class="table_error">
                            <el-date-picker  style="width: 200px"  v-model="addFrom.insuranceList[scope.$index].insuranceDate"  format="yyyy-MM-dd"   value-format="yyyy-MM-dd"
                              type="daterange"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" @change="bdrqChange($event,scope.$index)"  ></el-date-picker>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="备注"  min-width="100">
                      <template slot-scope="scope">
                        <div>
                          <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.remark'" :key="scope.$index"  class="table_error">
                            <el-input placeholder="" maxlength="10"
                              v-model.trim="addFrom.insuranceList[scope.$index].remark" ></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-form-item label=" " >
                   <el-checkbox v-model="addFrom.sfjnsb">是否缴纳社保</el-checkbox>
                  </el-form-item>
                  <el-form-item label="缴纳公司:" prop="shebaoCompany" v-if="addFrom.sfjnsb">
                    <el-input  placeholder=""  maxlength="20" v-model.trim="addFrom.shebaoCompany"></el-input>
                  </el-form-item>
                   <el-form-item label="缴纳金额:" prop="shebaoCosts" class="jiage"  v-if="addFrom.sfjnsb">
                    <el-input  placeholder="" v-number-input.float="2"   maxlength="20" v-model.trim="addFrom.shebaoCosts"></el-input>
                    <span class="danwei">元/月</span>
                  </el-form-item> -->
                   <br>
                  <el-form-item label="紧急联系人1:" prop="emergencyUserName1">
                    <el-input  placeholder=""  maxlength="20" v-model.trim="addFrom.emergencyUserName1"></el-input>
                  </el-form-item>
                  <el-form-item label="紧急联系电话:" prop="emergencyMobile1">
                    <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="addFrom.emergencyMobile1"></el-input>
                  </el-form-item>
                  <br>
                  <el-form-item label="紧急联系人2:" prop="emergencyUserName2">
                    <el-input  placeholder=""  maxlength="20" v-model.trim="addFrom.emergencyUserName2"></el-input>
                  </el-form-item>
                  <el-form-item label="紧急联系电话:" prop="emergencyMobile2">
                    <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="addFrom.emergencyMobile2"></el-input>
                  </el-form-item>
                  <br>
                  <el-form-item label="健康状况:" prop="healthCondition">
                    <el-input  placeholder="" maxlength="50"  v-model="addFrom.healthCondition" style=" width: 440px;"></el-input>
                  </el-form-item>

                </div>
                <div class="addressBox">
                  <h4 class="title">
                    <span><i class="fa fa-tags iconFont" aria-hidden="true"></i><span class="red"></span>体检结果</span>
                  </h4>
                </div>
                <div v-if="newImgFlag">
                    <div  style="width:100%">
                        <uploadImgs :imgList.sync='img5' :max=6 @remove="handleRemove5"></uploadImgs>
                        <span>最多上传 6 张照片</span>
                        <!-- <uploadImg :img='img5' key="5"   @remove ='handleRemove5'  @change ='imgPreview5'></uploadImg> -->
                    </div>
                </div>
            </div>
            </el-form>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="saveFn('addFrom')">确定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="开通账号" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="kztzVisible" @close="closeDialog" width="400px" center>
          <span>
            <el-form :inline="true" :rules="rules" :model="ktzhFrom" ref="ktzhFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
            <div class="inpBox">
                  <el-form-item label="账号:" prop="account">
                    <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="ktzhFrom.account"></el-input>
                  </el-form-item>
            </div>
            </el-form>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="kztzVisible = false">取 消</el-button>
            <el-button type="primary" @click="KTsaveFn('addFrom')">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 查看 -->
        <el-dialog title="查看详情" :close-on-click-modal="false" class="detailBox" :close-on-press-escape="false" :visible.sync="dialoglook" @close="closeDialog" width="1240px" center>
          <span>
            <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="130px" size="mini">
             <el-form-item label="所属分级：" label-width="100px" >
               <span style="width:300px">{{addFrom.teamOrgName}}/{{addFrom.operationOrgName}}</span>
            </el-form-item>
            <el-form-item label="绑定车数量限制：" label-width="140px" >
                <span>{{addFrom.bindCarNumber}}</span>
            </el-form-item>
            <div class="inpBox inpBoxA">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
            <div style="display: flex;">
              <div class="box" >
                <div class="imgBox">
                   <el-image
                      :src="addFrom.identityPhoto1Url"
                      :preview-src-list="[addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl]">
                    </el-image>
                    <h6 class="is-need">身份证正面</h6>
                </div>
                <div class="imgBox" style="margin-bottom:10px">
                      <el-image
                      :src="addFrom.identityPhoto2Url"
                      :preview-src-list="[addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url]">
                    </el-image>
                    <h6  class="is-need">身份证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      :src="addFrom.appendix1Url"
                      :preview-src-list="[addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证正面</h6>
                </div>
                <div class="imgBox" style="margin-bottom:10px">
                    <el-image
                      :src="addFrom.appendix2Url"
                      :preview-src-list="[addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      :src="addFrom.qualificationPhotoUrl"
                      :preview-src-list="[addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url]">
                    </el-image>
                    <h6  class="is-need">道路运输从业资格证</h6>
                </div>
              </div>
              <div>
                <div class="borderBox" style="padding-top:20px;margin-bottom:15px">
                  <el-form-item label="司机姓名:" prop="name">
                    <span>{{addFrom.name}}</span>
                  </el-form-item>
                  <el-form-item label="联系电话:" prop="mobile">
                    <span>{{addFrom.mobile}}</span>
                  </el-form-item>
                  <!-- <el-form-item label="入职日期:" prop="mobile">
                    <span>{{addFrom.joinedDate|dateFormat1}}</span>
                  </el-form-item> -->
                  <el-form-item label="身份证号:" prop="identityNo">
                    <span>{{addFrom.identityNo}}</span>
                  </el-form-item>
                  <el-form-item label="是否五险:" prop="address">
                    <span style="width:440px">{{['否','是'][addFrom.fiveInsurances]}}</span>
                  </el-form-item>
                  <el-form-item label="身份证开始日期:" prop="identityExpiringDate">
                    <span style="width:440px">{{addFrom.identityStratDate|dateFormat1}}至{{addFrom.identityExpiringDate}}</span>
                  </el-form-item>
                </div>
                <div class="borderBox" style="padding-top:20px;margin-bottom:15px">
                  <el-form-item label="驾驶证号:" prop="licenseNum">
                  <span>{{addFrom.licenseNum}}</span>
                  </el-form-item>
                  <br>
                   <el-form-item label="准驾车型:" prop="quasiDrivingModel" >
                  <span>{{addFrom.quasiDrivingModel}}</span>
                  </el-form-item>
                  <el-form-item label="驾驶证发证机关:" prop="issueAuthority" >
                  <span style="width:400px">{{addFrom.issueAuthority}}</span>
                  </el-form-item>
                  <br>
                  <el-form-item label="驾驶证开始日期:" prop="licenseNum">
                  <span style="width:300px">{{addFrom.validPeriodFrom|dateFormat1}}至{{addFrom.validPeriodTo}}</span>
                  </el-form-item>
                </div>
                <div class="borderBox" style="padding-top:20px;margin-bottom:15px">
                  <el-form-item label="从业资格证号:" label-width="200" prop="qualificationNum">
                  <span >{{addFrom.qualificationNum}}</span>
                  </el-form-item>
                  <el-form-item label="从业资格证有效期:" prop="licenseNum" label-width="140px">
                  <span style="width:300px">{{addFrom.qualificationTo|dateFormat1}}</span>
                  </el-form-item>
                </div>
                <div class="borderBox" style="margin-bottom:15px;padding: 10px;">
                  <div v-for="(item,index) in addFrom.personnelRecords" :key="index">
                    <el-form-item label="人事状态:" label-width="200" prop="licenseNum" style="margin-bottom: 5px !important;">
                      <span >{{item.changeType == '1' ? '在职' : '离职'}}</span>
                    </el-form-item>
                    <el-form-item :label="item.changeType == '1' ? '入职日期:' : '离职日期:'" label-width="100px" prop="licenseNum" style="margin-bottom: 5px !important;">
                      <span style="width:300px">{{item.changeTime|dateFormat1}}</span>
                    </el-form-item>
                    <el-form-item label="离职原因:" label-width="200" prop="licenseNum" v-if="item.changeType == '2'" style="margin-bottom: 5px !important;">
                      <span >{{item.reason}}</span>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>保险信息</span>
              </h4>
            </div>
            <div style="padding-bottom:16px"   >
              <el-table :data="addFrom.cDriverInsuranceList" class="bxBox"    bordersize="mini"  style="width: 100%" max-height="500px"  center border >
                <el-table-column type="index"  label="序号" width="60"></el-table-column>
                <el-table-column label="保险公司" min-width="120" property="insuranceCompany" ></el-table-column>
                <el-table-column label="保险项目" min-width="120" property="insuranceProject" ></el-table-column>
                <el-table-column label="最高保险金额(元)" min-width="120" property="maximumAmount" ></el-table-column>
                <el-table-column label="保费/年" min-width="120" property="insuranceCosts" ></el-table-column>
                <el-table-column label="保单起止日期"  min-width="140">
                  <template slot-scope="scope">
                    <div>
                      {{scope.row.insuranceDateFrom|dateFormat1}}至{{scope.row.insuranceDateTo|dateFormat1}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="备注" min-width="120" property="remark" ></el-table-column>
              </el-table>
               <el-form-item label="是否缴纳社保:" >
                <span>{{addFrom.shebaoFlag=='0'?'是':'否'}}</span>
              </el-form-item>
              <el-form-item label="缴纳公司:" prop="shebaoCompany" v-if="addFrom.shebaoFlag=='0'">
                 <span>{{addFrom.shebaoCompany}}</span>
              </el-form-item>
              <el-form-item label="缴纳金额:" prop="shebaoCosts" class="jiage"  v-if="addFrom.shebaoFlag=='0'">
                <span class="danwei">{{addFrom.shebaoCosts/100}}元/月</span>
              </el-form-item>
              <br>
            </div> -->
             <el-form-item label="紧急联系人1:" prop="emergencyUserName1">
                 <span>{{addFrom.emergencyUserName1}}</span>
              </el-form-item>
              <el-form-item label="紧急联系电话:" prop="emergencyMobile1">
                <span>{{addFrom.emergencyMobile1}}</span>
              </el-form-item>
              <br>
              <el-form-item label="紧急联系人2:" prop="emergencyUserName2">
                <span>{{addFrom.emergencyUserName2}}</span>
              </el-form-item>
              <el-form-item label="紧急联系电话:" prop="emergencyMobile2">
                <span>{{addFrom.emergencyMobile2}}</span>
              </el-form-item>
              <br>
              <el-form-item label="健康状况:" prop="healthCondition">
                <span style="width:600px">{{addFrom.healthCondition?addFrom.healthCondition:'-'}}</span>
              </el-form-item>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i><span class="red"></span>体检结果</span>
              </h4>
            </div>
            <div class="xqimgBox">
              <div class="imgBox1" v-if="addFrom.attachmentsList&&addFrom.attachmentsList.length>0">
                <el-image  v-for="(item,index) in addFrom.attachmentsList" :src="item.fileKeyUrl" :key="index" :preview-src-list="getSrcList(index,addFrom.attachmentsList)">
                </el-image>
              </div>
              <span v-else>暂无数据</span>
            </div>

          </div>
          </el-form>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialoglook = false">关闭</el-button>
          </span>
        </el-dialog>
        <el-dialog title="变更账号"  @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false"
          :visible.sync="bgzhMark" width="500px" center>
          <el-form :inline="true" :rules="rules" :model="bgzhFrom" ref="bgzhFrom" class="demo-form-inline jiaoyan" label-width="160px" size="mini">
            <el-form-item label="原账号:"  style="margin-top: 28px;">
              <el-input  placeholder="" maxlength="11" :readonly="true" class="disabled" v-number-input.float="0" v-model="bgzhFrom.account"></el-input>
            </el-form-item>
            <el-form-item label="新账号:" prop="newAccount">
              <el-input  placeholder="" maxlength="11" @blur="zhBlur()" v-number-input.float="0" v-model="bgzhFrom.newAccount"></el-input>
            </el-form-item>
            <div style="margin: 10px 121px;color: red">
              <span style="display:inline-block"> 注：变更账号需要得到使用者许可</span>
              <span style="display:inline-block;margin-left:30px">密码为原密码</span>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="bgzhMark = false">取 消</el-button>
            <el-button type="primary" @click="bgzhSave()">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 调拨 -->
        <el-dialog title="调拨"  :close-on-click-modal="false" :close-on-press-escape="false"
          :visible.sync="dbMark" width="600px" center>
          <el-form :inline="true" :rules="rules" :model="dbFrom" ref="dbFrom" class="demo-form-inline jiaoyan" label-width="160px" size="mini">
             <el-form-item label="调拨到：" label-width="100px" prop="suoshuOrgId">
               <el-cascader v-model="dbFrom.suoshuOrgId" style="width:400px" ref="zuzhicascader" @change="zuzhiChange" :options="BMlist"
               :props="{ expandTrigger:'hover',  label:'name',value:'id',emitPath:false, checkStrictly: true}"  ></el-cascader>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dbMark = false">取 消</el-button>
            <el-button type="primary" @click="dbSave()">确 定</el-button>
          </span>
        </el-dialog>
         <!-- 绑定承运商 -->
        <el-dialog  title="绑定承运商" :close-on-click-modal="false" :close-on-press-escape="false"  @close="bdcysFlag = false"  :visible.sync="bdcysFlag" width="400px" center>
          <div>
            <el-form  :inline="true" :rules="rules1"  ref="bdcysForm" :model="bdcysForm"  class="demo-form-inline jiaoyan"  label-width="90px"  size="mini"  >
            <el-form-item label="承运商 :" prop="customerName">
                <el-select  v-model="bdcysForm.customerName"  placeholder="请选择" clearable filterable  style="width:176px">
                  <template  v-for="item in CYSList">
                        <el-option  :label="item.customerName"  :value="item.customerName" :key="item.id"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="bdcysFlag = false">取 消</el-button>
            <el-button type="primary" @click="cysSaveFn()">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="离职" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="liZhiVisible" @close="liZhiClose" width="400px" center>
          <span>
            <el-form :inline="true" :rules="rules" :model="liZhiFrom" ref="liZhiFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini" v-if="liZhiVisible">
            <div class="inpBox">
              <el-form-item label="离职日期:" prop="resignDate">
                <el-date-picker
                  v-model="liZhiFrom.resignDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="离职原因:" prop="resignReason">
                <el-input type="textarea" v-model="liZhiFrom.resignReason" maxlength="100" :rows="3" style="width:180px;"></el-input>
              </el-form-item>
            </div>
            </el-form>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="liZhiClose">取 消</el-button>
            <el-button type="primary" @click="liZhiSaveFn('addFrom')">确 定</el-button>
          </span>
        </el-dialog>
  </div>
 </div>

</template>

<script>
// import {
//   zzauditHistoryList // 记录
// } from '@/api/consignment'
import shengShiXian from '@/components/common/shengShiXian.vue'
import SearchCollapse from '@/components/common/SearchCollapse.vue'
import { getBtn } from '@/utils/getButton'
import uploadImg from '@/components/uploadImg.vue'
import { compressImage } from '@/utils/compressImage'
import { emptyFn, dateTimeFormat, dateFormat, dateFormat1 } from '@/utils/util'
import { cDlists, cDadds, cDupdates, cDdeletes, getCDriverInfo, ocrIdentification, organizationTree, openAccount,
  detailDrivers, ocrCustomModelByFile, addBlackLists, delBlackLists, updateAccount, getDriverAccount, cDriverInfoDiaobo,
  tOverdueSetList, ocrModelList, driverBindCustomer, driverResign } from '@/api/vgs-driver2.0'
import { findCustomerInfoList } from '@/api/newTMS'
import DonMessage from '@/utils/message'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  components: {
    uploadImg, uploadImgs, SearchCollapse
  },
  data () {
    return {
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      // 组织机构树
      orgTreeData: [],
      currentData: {},
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      FKfrom: {
        SKlist: []
      },
      isEdits: [],
      isAdd: false,
      tableList: [],
      loading: false,
      addFrom: { jzcq: 2, sfzcq: 2 },
      ktzhFrom: {},
      title: '新增司机信息',
      img: [],
      img1: [],
      img2: [],
      img3: [],
      img4: [],
      img5: [],
      imgList: [],
      newImgFlag: false,
      flag: true,
      rules: {
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        xname: [
          { required: true, message: '请选择省市县', trigger: 'blur' }
        ],
        driverClassify: [
          { required: true, message: '请选择司机所属', trigger: ['blur', 'change'] }
        ],
        fiveInsurances: [
          { required: true, message: '请选择是否五险', trigger: ['blur', 'change'] }
        ],
        driverSalary: [
          { required: true, message: '请输入基本工资', trigger: 'blur' }
        ],
        driverSocialSecurity: [
          { required: true, message: '请输入社保费用', trigger: 'blur' }
        ],
        identityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        account: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        licenseNum: [
          { required: true, message: '请输入驾驶证号', trigger: 'blur' }
        ],
        certificateNum: [
          { required: true, message: '请输入驾驶证号档案号', trigger: 'blur' }
        ],
        qualificationNum: [
          { required: true, message: '请输入从业资格证号', trigger: 'blur' }
        ],
        driverTenantName: [
          { required: true, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        driverTenant: [
          { required: true, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        quasiDriving: [
          { required: true, message: '请选择准驾车型', trigger: 'blur' }
        ],
        issueAuthority: [
          { required: true, message: '请输入驾驶证发证机关', trigger: 'blur' }
        ],
        identityExpiringDate: [
          { required: true, message: '请选择身份证有效期', trigger: 'blur' }
        ],
        validPeriodFrom: [
          { required: true, message: '请选择驾照起始日期', trigger: 'blur' }
        ],
        validPeriodTo: [
          { required: true, message: '请选择驾照结束日期/个人', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入身份证地址', trigger: 'blur' }
        ],
        identityStratDate: [
          { required: true, message: '请选择身份证开始日期', trigger: 'blur' }
        ],
        joinedDate: [
          { required: true, message: '请选择入职日期', trigger: 'blur' }
        ],
        qualificationTo: [
          { required: true, message: '请选择从业资格证有效期', trigger: 'blur' }
        ],
        insuranceCompany: [
          { required: true, message: '请输入保险公司', trigger: 'blur' }
        ],
        insuranceProject: [
          { required: true, message: '请输入保险项目', trigger: 'blur' }
        ],
        maximumAmount: [
          { required: true, message: '请输入最高保险金额', trigger: 'blur' }
        ],
        insuranceCosts: [
          { required: true, message: '请输入保费/年', trigger: 'blur' }
        ],
        insuranceDate: [
          { required: true, message: '请选择起止日期', trigger: 'blur' }
        ],
        emergencyUserName1: [
          { required: true, message: '请输入紧急联系人', trigger: 'blur' }
        ],
        emergencyMobile1: [
          { required: true, message: '请输入紧急联系人电话', trigger: 'blur' },
          this.rule.mobile
        ],
        emergencyMobile2: [
          this.rule.mobile
        ],
        newAccount: [
          { required: true, message: '请输入新账号', trigger: 'blur' }
        ],
        shebaoCompany: [
          { required: true, message: '请输入缴纳公司', trigger: 'blur' }
        ],
        shebaoCosts: [
          { required: true, message: '请输入缴纳金额', trigger: 'blur' }
        ],
        suoshuOrgId: [
          { required: true, message: '请选择所属队组', trigger: 'blur' }
        ],
        resignDate: [
          { required: true, message: '请选择离职日期', trigger: 'blur' }
        ],
        resignReason: [
          { required: true, message: '请输入离职原因', trigger: 'blur' }
        ]
      },
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      zjcx: ['A1', 'A2', 'A3', 'B1', 'B2', 'C1', 'C2', 'C3', 'C4', 'D', 'E'],
      total: 0,
      value2: '',
      ids: [],
      dialogVisible: false,
      kztzVisible: false,
      dialoglook: false,
      disabled: false,
      hideUploadEditA: false,
      hideUploadEditB: false,
      hideUploadEditC: false,
      hideUploadEditD: false,
      ssdw: [], // 所属单位列表
      btnFlg: [],
      btnIdArr: ['00IM090100', '00IM090200', '00IM090300', '00IM090400', '00IM090500', '00IM090600', '00IM090700',
        '00IM090800', '00IM090900', '00IM090A00', '00IM090B00', '00IM090C00', '00IM090D00', '00IM090E00'],
      qualificationOverdueArr: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '已过期'
        }
      ],
      identityOverdueArr: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '已过期'
        }
      ],
      appendixOverdueArr: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '已过期'
        }
      ],
      activities: [],
      zhuhuCode: localStorage.getItem('tenantCode'),
      zuzhiquanming: '',
      BMlist: [],
      bgzhMark: false,
      bgzhFrom: {},
      dbMark: false,
      dbFrom: {},
      delBxIds: [],
      bjData: {},
      isDisable: false,
      rules1: {
        customerName: [
          { required: true, message: '请选择承运商', trigger: 'blur' }
        ]
      },
      bdcysFlag: false,
      bdcysForm: {},
      CYSList: [],
      liZhiVisible: false,
      liZhiFrom: {}
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/driverTow')
    // this.getList(this.searchFrom)
    if (this.$route.params.key) {
      this.$set(this.searchFrom, 'identityNo', this.$route.params.key)
    }
    if (this.$route.params.jobStatus) {
      this.$set(this.searchFrom, 'jobStatus', this.$route.params.jobStatus)
    }
    this.getTree(true)
    tOverdueSetList().then(res => {
      if (res.length > 0) {
        this.bjData = res[0]
      }
    })
    findCustomerInfoList({ businessType: 2 }).then(res => { this.CYSList = res })
  },
  mounted () {
    this.getHeight()
    setInterval(function () {
      document.querySelectorAll('.el-cascader-node__label').forEach(el => {
        el.onclick = function () {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
  },
  methods: {
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 168) + 'px'
      })
    },
    // 绑定承运商
    bdcysFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.bdcysForm.ids = selectData.map(itme => itme.id)
      this.bdcysFlag = true
    },
    cysSaveFn () {
      let json = this.CYSList.filter(item => item.customerName == this.bdcysForm.customerName)
      if (json.length > 0) {
        this.bdcysForm.customerTaxId = json[0].customerTaxId
        this.bdcysForm.customerId = json[0].id
      } else {
        this.$set(this.bdcysForm, 'customerName', null)
        this.bdcysForm.customerTaxId = null
        this.bdcysForm.customerId = null
      }

      this.$refs.bdcysForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          driverBindCustomer(this.bdcysForm).then(res => {
            loading.close()
            this.bdcysFlag = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: false,
              duration: 3000,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    async exportFn (val) {
      this.isDisable = true
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      await exportExcel(
        this.global.driverNameT + '/cDriverInfo/exportDriverInfo',
        form,
        '司机列表'
      )
      this.isDisable = false
    },
    // 超时报警颜色设置
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'identityExpiringDate' && row.identityDays < this.bjData.identityDays) {
        return { background: '#FEB0A4' }
      }
      if (column.property == 'validPeriodTo' && row.licenseDays < this.bjData.licenseDays) {
        return { background: '#FEB0A4' }
      }
      if (column.property == 'qualificationTo' && row.qualificationDays < this.bjData.qualificationDays) {
        return { background: '#FEB0A4' }
      }
    },
    // 体检报告点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.fileKeyUrl)
      })
      return urls
    },
    diaoboFn (row) {
      this.dbFrom = {
        suoshuOrgId: row.suoshuOrgId,
        id: row.id
      }
      // this.orgTreeData.forEach(item => {
      //   if (item.tenantCode == this.currentData.tenantCode) {
      //     let json = JSON.parse(JSON.stringify(item))
      //     this.BMlist = this.sAttributeList([json])
      //   }
      // })
      let jsonARR = JSON.parse(JSON.stringify(this.orgTreeData))
      this.BMlist = this.sAttributeList(jsonARR)
      this.dbMark = true
    },
    dbSave () {
      this.$refs.dbFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cDriverInfoDiaobo(this.dbFrom).then(res => {
            loading.close()
            this.dbMark = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    bgzhFn (row) {
      this.bgzhFrom = {}
      getDriverAccount({ driverId: row.id }).then(res => {
        this.bgzhMark = true
        this.$set(this.bgzhFrom, 'account', res.account)
        this.$set(this.bgzhFrom, 'id', res.id)
        this.$set(this.bgzhFrom, 'sourceType', 1)
      })
    },
    zhBlur () {
      if (this.bgzhFrom.newAccount == this.bgzhFrom.account) {
        this.$alert('新账号与原账号相同！', '系统提示')
        this.$set(this.bgzhFrom, 'newAccount', '')
      }
    },
    bgzhSave () {
      this.$refs.bgzhFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateAccount(this.bgzhFrom).then(res => {
            loading.close()
            // this.$alert('变更账号！', '系统提示')
            this.bgzhMark = false
            // this.recallMark = true
            this.$message({
              message: '变更账号成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 开通账号
    ktzhFn (row) {
      this.kztzVisible = true
      this.ktzhFrom.driverId = row.id
      this.ktzhFrom.businessCode = '4-3'// 自有司机4-3、市场4-1
      this.$set(this.ktzhFrom, 'account', row.mobile)
    },
    KTsaveFn () {
      this.$refs.ktzhFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          openAccount(this.ktzhFrom).then(res => {
            loading.close()
            this.kztzVisible = false
            this.$message({
              message: '开通成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    renderContent (h, { node, data, store }) {
      var n = '(' + data.driverNum + ')'
      return (
        <span class="custom-tree-node">
          <span>{node.label + n}</span>
        </span>)
    },
    // 拉黑
    laheiFn (row) {
      this.$confirm('是否执行拉黑操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addBlackLists({
          driverId: row.id
        }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 解锁
    jiesuoFn (row) {
      this.$confirm('是否执行解锁操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        delBlackLists({
          driverId: row.id
        }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 保险日期修改
    bdrqChange (e, index) {
      this.$set(this.addFrom.insuranceList[index], 'insuranceDateFrom', e[0])
      this.$set(this.addFrom.insuranceList[index], 'insuranceDateTo', e[1])
    },
    // 添加保险
    addGoodFn (row) {
      let json = { ...row }
      delete json.id
      this.addFrom.insuranceList.push(json)
    },
    // 删除保险
    delGoodFn (index) {
      if (this.addFrom.insuranceList.length == 1) {
        this.$alert('最后一条数据不能删除', '系统提示')
        return
      }
      if (this.addFrom.insuranceList[index].id) {
        this.delBxIds.push(this.addFrom.insuranceList[index].id)
      }
      this.addFrom.insuranceList.splice(index, 1)
    },
    zuzhiChange (e) {
      const cascaderInstance = this.$refs.zuzhicascader // 假设你的el - cascader组件有ref="cascader"
      const checkedNodes = cascaderInstance.getCheckedNodes()[0]
      console.log(checkedNodes)
      this.$set(this.dbFrom, 'suoshuOrgName', checkedNodes.data.name)
      this.$set(this.dbFrom, 'suoshuOrgId', checkedNodes.data.id)
      this.$set(this.dbFrom, 'suoshuOrgCode', checkedNodes.data.code)
      this.$set(this.dbFrom, 'suoshuOrgType', checkedNodes.data.orgType)
    },
    // 点击树
    handleNodeClick (data, node) {
      this.currentData = {
        tenantCode: data.tenantCode,
        orgId: data.id,
        code: data.code,
        name: data.name,
        orgType: data.orgType//  1公司,2小队，3小组
      }
      if (this.currentData.orgType == 1) {
        this.$set(this.searchFrom, 'companyOrgId', this.currentData.orgId)
        this.$set(this.searchFrom, 'teamOrgId', null)
        this.$set(this.searchFrom, 'operationOrgId', null)
      }
      if (this.currentData.orgType == 2) {
        this.$set(this.searchFrom, 'companyOrgId', null)
        this.$set(this.searchFrom, 'teamOrgId', this.currentData.orgId)
        this.$set(this.searchFrom, 'operationOrgId', null)
      }
      if (this.currentData.orgType == 3) {
        this.$set(this.searchFrom, 'companyOrgId', null)
        this.$set(this.searchFrom, 'teamOrgId', null)
        this.$set(this.searchFrom, 'operationOrgId', this.currentData.orgId)
      }
      this.getList(this.searchFrom)
      // let parentNames = []
      // let currentNode = node
      // if (data.orgType == 3) {
      //   while (currentNode.parent) {
      //     if (currentNode.parent.data.name) {
      //       parentNames.unshift(currentNode.parent.data.name)
      //     }
      //     currentNode = currentNode.parent
      //   }
      //   parentNames.push(data.name)
      //   this.zuzhiquanming = parentNames.join('/')
      // }
    },
    // 获取左侧菜单
    getTree (flag) {
      organizationTree({ tenantCode: this.zhuhuCode }).then((res) => {
        this.orgTreeData = res
        if (this.orgTreeData.length != 0) {
          this.$nextTick(function () {
            // console.log(this.$refs.orgTree);
            if (this.$refs.orgTree) {
              this.$refs.orgTree.setCurrentKey(this.currentData.orgId)
            // console.log(this.currentData.orgId + "、、、");
            // this.tableList = this.$refs.orgTree.getNode(this.currentData.parentId).data.children
            }
          })
          if (flag) {
            this.currentData = {
              tenantCode: this.orgTreeData[0].tenantCode,
              orgId: this.orgTreeData[0].id,
              code: this.orgTreeData[0].code,
              name: this.orgTreeData[0].name,
              orgType: this.orgTreeData[0].orgType
            }
          }
          if (this.currentData.orgType == 1) {
            this.$set(this.searchFrom, 'companyOrgId', this.currentData.orgId)
            this.$set(this.searchFrom, 'teamOrgId', null)
            this.$set(this.searchFrom, 'operationOrgId', null)
          }
          if (this.currentData.orgType == 2) {
            this.$set(this.searchFrom, 'teamOrgId', this.currentData.orgId)
            this.$set(this.searchFrom, 'operationOrgId', null)
          }
          if (this.currentData.orgType == 3) {
            this.$set(this.searchFrom, 'operationOrgId', this.currentData.orgId)
          }
          this.getList(this.searchFrom)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 添加保存
    saveFn (formName) {
      console.log(this.addFrom)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addFrom.sfzcq == 1) {
            this.addFrom.identityExpiringDate = '长期'
          }
          if (this.addFrom.jzcq == 1) {
            this.addFrom.validPeriodTo = '长期'
          }
          this.addFrom.driverClassify = 2
          this.addFrom.insuranceIds = this.delBxIds
          this.addFrom.shebaoFlag = this.addFrom.sfjnsb ? 0 : 1
          this.addFrom.quasiDrivingModel = this.addFrom.quasiDriving.join(',')
          if (this.isAdd) { // 新增需要的逻辑
            if (this.currentData.orgType == 1) {
              this.addFrom.companyOrgName = this.currentData.name
              this.addFrom.companyOrgCode = this.currentData.code
              this.addFrom.companyOrgId = this.currentData.orgId
            }
            if (this.currentData.orgType == 2) {
              this.addFrom.teamOrgName = this.currentData.name
              this.addFrom.teamOrgCode = this.currentData.code
              this.addFrom.teamOrgId = this.currentData.orgId
            }
            if (this.currentData.orgType == 3) {
              this.addFrom.operationOrgName = this.currentData.name
              this.addFrom.operationOrgCode = this.currentData.code
              this.addFrom.operationOrgId = this.currentData.orgId
            }
            this.addFrom.suoshuOrgType = this.currentData.orgType
            this.addFrom.suoshuOrgId = this.currentData.orgId
            this.addFrom.suoshuOrgCode = this.currentData.code
            this.addFrom.suoshuOrgName = this.currentData.name
            this.addFrom.currStatus = 3
          }
          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(this.addFrom))
          // 体检报告支持多张图片
          console.log(this.img5)
          this.img5.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          if (this.imgList.length == 5) {
            let arr = []
            for (let i = 0; i < this.imgList.length; i++) {
              if (this.imgList[i]) {
                if (this.imgList[i] != 1) {
                  arr.push({ img: this.imgList[i], index: i })
                }
              } else {
                if (i != 5) { // 体检报告
                  this.$alert('请上传证件信息', '系统提示')
                  return
                }
              }
            }
            if (arr.length > 0) {
              for (let i = 0; i < arr.length; i++) {
                let a = i
                compressImage(arr[i].img.url, arr[i].img.raw, {
                  width: 1000
                }).then(result => {
                  imgfile.append('file' + arr[a].index, result)// result即为压缩后的结果
                  if (a == arr.length - 1) {
                    if (this.isAdd) {
                      this.addJK(imgfile)
                    } else {
                      this.xiugaiJK(imgfile)
                    }
                  }
                })
              }
            } else {
              if (this.isAdd) {
                this.addJK(imgfile)
              } else {
                this.xiugaiJK(imgfile)
              }
            }
          } else {
            this.$alert('请上传证件信息', '系统提示')
          }
        } else {
          return false
        }
      })
    },
    // 图片上传
    handleRemove (data) {
      this.imgList[0] = null
    },
    async imgPreview (data) {
      this.imgList[0] = data[0]
      let imgfile = new FormData()
      let yasuo = ''
      await compressImage(data[0].url, data[0].raw, {
        width: 600
      }).then(result => {
        yasuo = result
      })
      imgfile.set('params', JSON.stringify({ side: 'front', type: 'idcard' }))
      imgfile.append('file', yasuo)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      ocrIdentification(imgfile).then(res => {
        loading.close()
        if (res) {
          this.$set(this.addFrom, 'name', res.name)
          this.$set(this.addFrom, 'address', res.address)
          this.$set(this.addFrom, 'identityNo', res.idNumber)
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    handleRemove1 (data) {
      this.imgList[1] = null
    },
    async imgPreview1 (data) { // 身份证背面
      this.imgList[1] = data[0]
      let imgfile = new FormData()
      let yasuo = ''
      await compressImage(data[0].url, data[0].raw, {
        width: 600
      }).then(result => {
        yasuo = result
      })
      imgfile.set('params', JSON.stringify({ side: 'back', type: 'idcard' }))
      imgfile.append('file', yasuo)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      ocrIdentification(imgfile).then(res => {
        loading.close()
        if (res) {
          if (this.isDate(this.riqiFormat(res.issuedAt))) {
            this.$set(this.addFrom, 'identityStratDate', this.riqiFormat(res.issuedAt))
          } else {
            this.$set(this.addFrom, 'identityStratDate', null)
          }
          if (res.expiredAt1 == '长期' || res.expiredAt1 == '长') {
            this.$set(this.addFrom, 'sfzcq', 1)
            this.$set(this.addFrom, 'identityExpiringDate', '长期')
          } else {
            if (this.isDate(res.expiredAt)) {
              this.$set(this.addFrom, 'identityExpiringDate', res.expiredAt)
            } else {
              this.$set(this.addFrom, 'identityExpiringDate', null)
            }
          }
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 日期处理
    riqiFormat (cellValue) {
      let y = cellValue.substring(0, 4)
      let M = cellValue.substring(4, 6)
      let d = cellValue.substring(6, 8)
      return y + '-' + M + '-' + d
    },
    handleRemove2 (data) {
      this.imgList[2] = null
    },
    async imgPreview2 (data) { // 驾驶证正面面
      this.imgList[2] = data[0]
      let imgfile = new FormData()
      let yasuo = ''
      await compressImage(data[0].url, data[0].raw, {
        width: 600
      }).then(result => {
        yasuo = result
      })
      imgfile.set('params', JSON.stringify({ side: 'front', type: 'driverLicense' }))
      imgfile.append('file', yasuo)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      ocrIdentification(imgfile).then(res => {
        loading.close()
        if (res.issuingUnit) {
          this.$set(this.addFrom, 'issueAuthority', res.issuingUnit)
          if (this.isDate(this.riqiFormat(res.termOfValidity))) {
            this.$set(this.addFrom, 'validPeriodFrom', this.riqiFormat(res.termOfValidity))
          } else {
            this.$set(this.addFrom, 'validPeriodFrom', null)
          }
          if (res.to == '长期' || res.to == '长' || res.termOfValidity == '长期') {
            this.$set(this.addFrom, 'jzcq', 1)
            this.$set(this.addFrom, 'validPeriodTo', '长期')
          } else {
            if (this.isDate(this.riqiFormat(res.to))) {
              this.$set(this.addFrom, 'validPeriodTo', this.riqiFormat(res.to))
            } else {
              this.$set(this.addFrom, 'validPeriodTo', null)
            }
          }
          if (res.quasiDrivingModel) {
            this.$set(this.addFrom, 'quasiDriving', res.quasiDrivingModel.split(','))
          }
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    handleRemove3 (data) {
      this.imgList[3] = null
    },
    async imgPreview3 (data) { // 驾驶证背面
      this.imgList[3] = data[0]
      let imgfile = new FormData()
      let yasuo = ''
      await compressImage(data[0].url, data[0].raw, {
        width: 600
      }).then(result => {
        yasuo = result
      })
      imgfile.set('params', JSON.stringify({ side: 'back', type: 'driverLicense' }))
      imgfile.append('file', yasuo)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      ocrIdentification(imgfile).then(res => {
        loading.close()
        console.log(res)
        if (res) {
          this.$set(this.addFrom, 'licenseNum', res.certificateNo)
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    handleRemove4 (data) {
      this.imgList[4] = null
    },
    isDate (str) {
      return /^\d{4}-\d{2}-\d{2}$/.test(str) || /^(\d{4})年(\d{2})月(\d{2})日$/.test(str)
    },
    replaceChineseDate (str) {
      const year = str.match(/\d+年/) // 匹配年份，例如"2023年"
      const month = str.match(/\d+月/) // 匹配月份，例如"03月"
      const day = str.match(/\d+日/) // 匹配日期，例如"15日"

      if (year && month && day) {
        return str.replace(year[0], year[0].replace(/年/, '-')).replace(month[0], month[0].replace(/月/, '-')).replace(day[0], day[0].replace(/日/, ''))
      } else {
        return str // 如果不匹配，则返回原字符串
      }
    },
    async imgPreview4 (data) { // 从业资格证
      this.imgList[4] = data[0]
      let imgfile = new FormData()
      let yasuo = ''
      await compressImage(data[0].url, data[0].raw, {
        width: 600
      }).then(result => {
        yasuo = result
      })
      ocrModelList({ modelName: '道路运输从业资格证' }).then(res => {
        let Id = JSON.parse(res)[0].id
        imgfile.set('params', JSON.stringify({ modelId: Id }))
        imgfile.append('file', yasuo)
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        ocrCustomModelByFile(imgfile).then(res => {
          loading.close()
          console.log(res)
          if (res) {
            let json = JSON.parse(res)
            this.$set(this.addFrom, 'qualificationNum', json.certificateNo)
            if (this.isDate(json.endDateA)) {
              this.$set(this.addFrom, 'qualificationTo', this.replaceChineseDate(json.endDateA))
            } else {
              this.$set(this.addFrom, 'qualificationTo', null)
            }
          }
        }).catch(error => {
          loading.close()
        })
      })
    },
    handleRemove5 (data) {
      if (data.id) {
        this.addFrom.deleteAttachmentsIds.push(data.id)
      }
    },
    imgPreview5 (data) {
      this.img5 = [data[0]]
      this.imgList[5] = data[0]
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.driverClassify = 2
      cDlists(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 地区选中
    handleChange (value) {
      if (value) {
        this.addFrom.provinceCode = value[0].areaCode
        this.addFrom.cityCode = value[1].areaCode
        this.addFrom.areaCode = value[2].areaCode
        this.addFrom.provinceName = value[0].name
        this.addFrom.cityName = value[1].name
        this.addFrom.areaName = value[2].name
        this.$set(this.addFrom, 'xname', value[0].name)
      }
    },

    // 司机添加
    addDeiver () {
      this.title = '新增司机信息'
      this.dialogVisible = true
      this.isAdd = true
      this.newImgFlag = true
      this.addFrom = {
        jzcq: 2,
        sfzcq: 2,
        bindCarNumber: 1,
        insuranceList: [] }
      this.flag = true
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
      this.img5 = []
    },
    // 获取司机信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.newImgFlag = false
        getCDriverInfo({ identityNo: this.addFrom.identityNo }).then(res => {
          loading.close()
          if (res.id) {
            this.addFrom = res
            this.addFrom.operationOrgId = this.currentData.orgId
            this.addFrom.operationOrgName = this.zuzhiquanming
            this.addFrom.operationOrgCode = this.currentData.code
            if (this.addFrom.driverClassify == 1) {
              if (res.driverTenantCode == '') {
                this.$set(this.addFrom, 'driverTenant', res.driverTenantName)
              } else {
                this.$set(this.addFrom, 'driverTenant', { tenantCode: res.driverTenantCode, tenantName: res.driverTenantName })
              }
            }
            if (res.identityPhoto1Url) {
              this.$set(this.img, 0, { status: 'ready', url: res.identityPhoto1Url })
              this.$set(this.imgList, 0, 1)
            }
            if (res.identityPhoto2Url) {
              this.$set(this.img1, 0, { status: 'ready', url: res.identityPhoto2Url })
              this.$set(this.imgList, 1, 1)
            }
            if (res.appendix1Url) {
              this.$set(this.img2, 0, { status: 'ready', url: res.appendix1Url })
              this.$set(this.imgList, 2, 1)
            }
            if (res.appendix2Url) {
              this.$set(this.img3, 0, { status: 'ready', url: res.appendix2Url })
              this.$set(this.imgList, 3, 1)
            }
            if (res.qualificationPhotoUrl) {
              this.$set(this.img4, 0, { status: 'ready', url: res.qualificationPhotoUrl })
              this.$set(this.imgList, 4, 1)
            }
            this.newImgFlag = true
            this.FKfrom.SKlist = res.cDriverBankCardList
            this.isEdits = []
            res.cDriverBankCardList.forEach(item => {
              this.isEdits.push(false)
            })
          } else {
            let identityNo = this.addFrom.identityNo
            this.addFrom = {
              identityNo: identityNo
            }
            this.addFrom.operationOrgId = this.currentData.orgId
            this.addFrom.operationOrgName = this.zuzhiquanming
            this.addFrom.operationOrgCode = this.currentData.code
            this.imgList = []
            this.img = []
            this.img1 = []
            this.img2 = []
            this.img3 = []
            this.img4 = []
            this.img5 = []
            this.newImgFlag = true
          }
          this.$set(this.addFrom, 'licenseNum', this.addFrom.identityNo)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 查看
    lookFn (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      detailDrivers({ driverId: row.id }).then(res => {
        loading.close()
        this.addFrom = res
        this.FKfrom.SKlist = res.cDriverBankCardList
        res.cDriverInsuranceList.forEach(item => {
          this.$set(item, 'insuranceCosts', item.insuranceCosts / 100)
          this.$set(item, 'maximumAmount', item.maximumAmount / 100)
        })
        this.dialoglook = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 递归判断列表，把最后的children设为undefined
    sAttributeList (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.sAttributeList(data[i].children)
        }
      }
      return data
    },
    // 修改
    modifyDeiver (row) {
      this.title = '修改司机信息'
      if (this.$refs.addFrom !== undefined) {
        this.$refs.addFrom.resetFields()
      }
      this.addFrom = {}
      if (this.$refs.table) {
        this.$refs.table.clearSelection()
      }
      this.rules1 = []
      this.FKfrom.SKlist = []
      this.FKfrom.driverId = null
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
      this.img5 = []
      this.newImgFlag = false
      this.flag = false
      this.flag = true
      this.dialogVisible = true
      this.isAdd = false
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      detailDrivers({ driverId: row.id }).then(res => {
        loading.close()
        this.addFrom = JSON.parse(JSON.stringify(res))
        this.$set(this.addFrom, 'sfjnsb', this.addFrom.shebaoFlag != 1)
        this.$set(this.addFrom, 'xname', this.addFrom.provinceName)
        if (row.quasiDrivingModel) {
          this.$set(this.addFrom, 'quasiDriving', row.quasiDrivingModel.split(','))
        }
        if (row.identityPhoto1Url) {
          this.$set(this.img, 0, { status: 'ready', url: row.identityPhoto1Url })
          this.$set(this.imgList, 0, 1)
        }
        if (row.identityPhoto2Url) {
          this.$set(this.img1, 0, { status: 'ready', url: row.identityPhoto2Url })
          this.$set(this.imgList, 1, 1)
        }
        if (row.appendix1Url) {
          this.$set(this.img2, 0, { status: 'ready', url: row.appendix1Url })
          this.$set(this.imgList, 2, 1)
        }
        if (row.appendix2Url) {
          this.$set(this.img3, 0, { status: 'ready', url: row.appendix2Url })
          this.$set(this.imgList, 3, 1)
        }
        if (row.qualificationPhotoUrl) {
          this.$set(this.img4, 0, { status: 'ready', url: row.qualificationPhotoUrl })
          this.$set(this.imgList, 4, 1)
        }
        if (res.attachmentsList.length > 0) {
          res.attachmentsList.forEach(item => {
            this.img5.push({ status: 'ready', url: item.fileKeyUrl, id: item.id })
          })
          // this.$set(this.img5, 0, { status: 'ready', url: row.physicalExaminationResultsUrl })
          // this.$set(this.imgList, 5, 1)
        }
        if (this.addFrom.identityExpiringDate == '长期') {
          this.$set(this.addFrom, 'sfzcq', 1)
          this.$set(this.addFrom, 'identityExpiringDate', null)
        } else {
          this.$set(this.addFrom, 'sfzcq', 2)
        }
        if (this.addFrom.validPeriodTo == '长期') {
          this.$set(this.addFrom, 'jzcq', 1)
          this.$set(this.addFrom, 'validPeriodTo', null)
        } else {
          this.$set(this.addFrom, 'jzcq', 2)
        }
        this.$set(this.addFrom, 'identityStratDate', dateFormat1(res.identityStratDate))
        this.$set(this.addFrom, 'validPeriodFrom', dateFormat1(res.validPeriodFrom))
        if (res.qualificationTo) {
          this.$set(this.addFrom, 'qualificationTo', dateFormat1(res.qualificationTo))
        }
        this.$set(this.addFrom, 'shebaoCosts', res.shebaoCosts / 100)
        let arrbx = []
        res.cDriverInsuranceList.forEach(item => {
          this.$set(item, 'insuranceDate', [dateFormat1(item.insuranceDateFrom), dateFormat1(item.insuranceDateTo)])
          this.$set(item, 'insuranceCosts', item.insuranceCosts / 100)
          this.$set(item, 'maximumAmount', item.maximumAmount / 100)
          arrbx.push(item)
        })
        if (arrbx.length == 0) {
          this.$set(this.addFrom, 'insuranceList', [])
        } else {
          this.$set(this.addFrom, 'insuranceList', arrbx)
        }
        this.newImgFlag = true
        this.dialogVisible = true
        this.isAdd = false
        this.addFrom.deleteAttachmentsIds = []
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },

    // 添加接口
    addJK (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      cDadds(data).then(res => {
        loading.close()
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.getList(this.searchFrom)
        this.getTree()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 修改接口
    xiugaiJK (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      cDupdates(data).then(res => {
        loading.close()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.getList(this.searchFrom)
        this.getTree()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除
    delDeiver () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        selectData.some(item => {
          this.ids.push(item.id)
        })
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cDdeletes({ ids: this.ids }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    closeDialogB (formName) {
      this.$refs[formName].resetFields()
      this.addFrom = {}
      this.imgList = []
    },
    closeDialog () {

    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
      if (this.currentData.orgType == 1) {
        this.$set(this.searchFrom, 'companyOrgId', this.currentData.orgId)
        this.$set(this.searchFrom, 'teamOrgId', null)
        this.$set(this.searchFrom, 'operationOrgId', null)
      }
      if (this.currentData.orgType == 2) {
        this.$set(this.searchFrom, 'companyOrgId', null)
        this.$set(this.searchFrom, 'teamOrgId', this.currentData.orgId)
        this.$set(this.searchFrom, 'operationOrgId', null)
      }
      if (this.currentData.orgType == 3) {
        this.$set(this.searchFrom, 'companyOrgId', null)
        this.$set(this.searchFrom, 'teamOrgId', null)
        this.$set(this.searchFrom, 'operationOrgId', this.currentData.orgId)
      }
      this.searchFn()
    },
    liZhiFn (row) {
      this.liZhiVisible = true
      this.$set(this.liZhiFrom, 'driverId', row.id)
    },
    liZhiClose () {
      this.liZhiVisible = false
      this.liZhiFrom = {}
    },
    liZhiSaveFn () {
      this.$refs.liZhiFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          driverResign(this.liZhiFrom).then(res => {
            loading.close()
            this.liZhiVisible = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
// .inpBox .el-date-editor{
//       width: 350px!important;
// }
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}
.addressBox{
  display: flex!important;
  justify-content: space-between;
  margin-bottom: 10px;
  .title{
    margin: 0!important;
  }
}
.FKbox{
  /deep/ .el-form-item--mini.el-form-item{
    margin: 4px;
    margin-bottom: 16px;
  }
}
.box{
  .imgBox{
    display: flex;
      margin-right:20px;
    flex-direction: column;
    width: 240px;
    /deep/.el-upload--picture-card,/deep/.el-upload-dragger{
      width: 240px;
      height: 120px;
      background-color:transparent;
      background-image: url(../../../../assets/images/upload1.png);
      background-size: 100%;
      background-position: 50% 50%;
    }
  }
  h6{
    text-align: center;
    margin: 15px;
    margin-top: -23px;
    font-size: 12px;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
    width: 240px;
    height: 120px;
  }
}
.detailBox{
  .imgBox{
    height: 130px;
  }

}
.detailBox .el-form-item span{
  display:inline-block;
  width: 150px;
}
.detailBox /deep/ .el-date-editor--date .el-input__inner{
  border: none;
  font-size: 14px;
}
.jiaoyan .inpBoxA /deep/.el-date-editor .el-input__inner{
  width: 150px;
}
.jiaoyan .inpBoxA /deep/.el-form-item__content{
 width: 150px;
}
.borderBox .el-form-item--mini.el-form-item{
      margin-bottom: 30px !important;
}
.redBtn{
  width:60px;
  height:28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  background-color: red;
  border-radius: 5px;
  font-size:14px;
  margin:0 auto;
}
.greenBtn{
  width:60px;
  height:28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  background-color: #09bb07;
  border-radius: 5px;
  font-size:14px;
  margin:0 auto;
}
.treeBigBox{
  display:flex;
  font-size: 14px;
}
.treeBox{
   width: 100%;
  text-align: center;
  padding:0;
  height: calc(100vh - 156px);
  overflow: auto;
}
.title{
  width: 100%;
  height: 36px;
  background: #D8E3F8;
  display: flex;
  align-items: center;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 14px;
  .xian{
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: rgba(11, 79, 214, 100);
    margin-right: 4px;
  }
}
.right{
  // flex: 1;
  // width: 75%;
  width: calc(100% - 260px);
}
.boxLeft{
  // width:30%;
  width:260px;
  border-right: 1px dashed #ddd;
  box-sizing: border-box;
}
/deep/.el-tree-node__content{
  white-space: nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.box1{
  font-size: 14px;
  // padding: 10px 20px;
  padding: 0px 20px;
  .boxItem{
    display: flex;
    align-items: center;
    margin: 28px 0;
    padding-bottom: 28px;
    border-bottom: 1px dashed #ddd;
    .title1{
      display: inline-block;
      // width: 200px;
      width: 260px;
      margin-right: 25px;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    margin-bottom: 6px;
  }
  .fa{
    font-size: 18px;
    color:#0B4FD6 ;
    margin-right: 8px;
  }
}
.borderBox{
  border:1px solid #ccc;
  padding: 20px 10px;
  border-radius: 10px;
}
.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
.bxBox{
  margin-bottom: 16px;
   /deep/.el-form-item__content{
    width: 100%!important;;
  }
}
/deep/ .el-upload-list__item:first-child{
margin-top: 0px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item{
  margin: 0px;
  margin-right: 10px;
}
.imgBox1{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin: 10px;
  }
}
/deep/.el-tree{
  height: 100%;
}

</style>
